import { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations } from "./translations";

const LangCtx = createContext({ lang: "de", t: translations.de, setLang: () => {} });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "de";
    return localStorage.getItem("aleger_lang") || "de";
  });

  // We only persist the language and set the <html lang> attribute here.
  // <title> and <meta name="description"> are handled by SeoHead/react-helmet
  // so that per-page overrides on /products/edgeone, /use-cases/* work correctly.
  useEffect(() => {
    localStorage.setItem("aleger_lang", lang);
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t: translations[lang] }), [lang]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export const useLang = () => useContext(LangCtx);
